import { forwardRef } from 'react';
import { WithChildren } from '@optimus-web/common';
import { useTimelineBlockOverbookingErrorCheck } from '../utils/useTimelineBlockOverbookingErrorCheck';
import Canvas, { Props as CanvasProps } from './Canvas';

type CanvasWrapperProps = CanvasProps & WithChildren;

/**
 * This component is here only as a functional component wrapper above current Canvas so
 * we could use hooks and such stuffs
 */
export const CanvasWrapper = forwardRef((props: CanvasWrapperProps, ref) => {
    const setNewReservationInfo = useTimelineBlockOverbookingErrorCheck(props);

    return <Canvas ref={ref} {...props} handleConfirmNewReservation={setNewReservationInfo} />;
});
